interface Config {
  REFRESH_TOKEN_NAME: string;
  ACCESS_TOKEN_NAME: string;
  PARTNER_COOKIE_NAME: string;
  LOGGED_IN_COOKIE: string;
  COOKIE_TOKEN_EXPIRES: string;
  SENTRY_DSN?: string;
}

const defaultConfig: Config = {
  REFRESH_TOKEN_NAME: 'rt',
  ACCESS_TOKEN_NAME: 'at',
  PARTNER_COOKIE_NAME: 'pid',
  LOGGED_IN_COOKIE: 'isLoggedIn',
  COOKIE_TOKEN_EXPIRES: 'exp',
  SENTRY_DSN: 'https://ac8e66ecf9c098f3d7ff1b52137ecdb3@o4509588936327168.ingest.us.sentry.io/4509588948254720',
};

const stageConfig: Config = {
  REFRESH_TOKEN_NAME: 'stage.rt',
  ACCESS_TOKEN_NAME: 'stage.at',
  PARTNER_COOKIE_NAME: 'stage.pid',
  LOGGED_IN_COOKIE: 'stage.isLoggedIn',
  COOKIE_TOKEN_EXPIRES: 'stage.exp',
  SENTRY_DSN: 'https://ac8e66ecf9c098f3d7ff1b52137ecdb3@o4509588936327168.ingest.us.sentry.io/4509588948254720',
};

function setConfig(): Config {
  if (/stage/.test(window.location.hostname) || process.env.REACT_APP_ENV === 'stage') {
    return stageConfig;
  } else {
    return defaultConfig;
  }
}

export default setConfig();

/**
 * Routes where session refresh should be skipped to avoid unnecessary 401s.
 * Used by SessionProvider and error handlers.
 */
export const AUTH_PATHS = ['/logout', '/login', '/sso', '/callback'] as const;

/**
 * SSO paths that trigger redirect to Pack app for site_manager/site_associate roles.
 * Used by GatewayAxiosClient interceptor.
 */
export const PACK_REDIRECT_PATHS = ['/sso/login', '/sso/changeContext', '/sso/refresh', '/sso/refresh-poll'] as const;
